/**
 * L2-P1: moved to @miq/shared-models (constants/pagination.const.ts). This shim keeps the old
 * import path working; new code should import from '@miq/shared-models'.
 */
export { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS, LEADS_PAGE_SIZE, LEADS_PAGE_SIZE_OPTIONS } from '@miq/shared-models';
